import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "./sidebar";

const Layout = () => {
  return (
    <Container fluid>
      <Row>
        <Col
          xs={{ span: 12, order: 2 }}
          md={{ span: 12, order: 2 }}
          lg={{ span: 3, order: 1 }}
          // xxl={{ span: 2, order: 1 }}
        >
         <Sidebar/>
        </Col>
        <Col xs={{ span: 12, order: 1 }}
        md={{ span: 12, order: 1 }}
        lg={{ span: 9, order: 2 }}
   >Mapping</Col>
      </Row>
    </Container>
  );
};
export default Layout;
